/* INTEGY V625 — virtual collection fallback sort owner.
   Shopify has zero native members for a few rescued collections (Mini XRT/Mini Slash),
   so Liquid renders verified fallback products. Shopify's sort_by parameter cannot sort
   those fallback cards server-side. This owner applies title/price sorts to that small
   DOM-only set after first paint. */
(function () {
  'use strict';
  function text(node, selector) {
    var el = node && node.querySelector(selector);
    return String(el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function price(node) {
    var value = text(node, '.productitem--price .money, .productitem--price, [data-price]');
    var match = value.replace(/,/g, '').match(/\$?([0-9]+(?:\.[0-9]+)?)/);
    return match ? Number(match[1]) : 0;
  }
  function title(node) { return text(node, '.productitem--title a, .productitem--title'); }
  function sortGrid() {
    var grid = document.querySelector('[data-integy-v453-fallback-grid]');
    if (!grid) return;
    var mode = new URLSearchParams(location.search).get('sort_by') || '';
    if (!/^(?:title|price)-(?:ascending|descending)$/.test(mode)) return;
    var cards = Array.prototype.slice.call(grid.children).filter(function (el) { return el.matches('.productgrid--item,[data-product-item]'); });
    if (cards.length < 2) return;
    var descending = /-descending$/.test(mode);
    var isPrice = /^price-/.test(mode);
    cards.sort(function (a, b) {
      var result;
      if (isPrice) result = price(a) - price(b);
      else result = title(a).localeCompare(title(b), undefined, { numeric: true, sensitivity: 'base' });
      return descending ? -result : result;
    });
    cards.forEach(function (card) { grid.appendChild(card); });
    grid.setAttribute('data-integy-v625-sort-applied', mode);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sortGrid, { once: true });
  else sortGrid();
  window.addEventListener('pageshow', function (event) { if (event && event.persisted) sortGrid(); });
})();
